// Libs
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import * as Yup from 'yup';
import { FormikProps } from 'formik';

// Own Libs
import {
  Button,
  ColumnProps,
  FormContext,
  FormDatePicker,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormSwitch,
  FormTextArea,
  MasterDetailForm,
  OptionProps,
  Row,
  Table,
  Widget,
} from '@digital/ui';

//Api
import {
  AbaDadosGerais,
  getDadosGerais,
  getDemanda,
  devolverDemanda,
  aprovarDemanda,
  Demanda,
  getAnexoFormularioReqCompraApi,
  downloadAnexoFormularioReqCompra,
  updateAnexoFormularioReqCompraAprovacao,
  downloadAnexoDemanda,
  viewAnexoDemanda,
  excluirAnexo,
  updateAnexoAprovacao,
  assumirDemanda,
  baixarTudoDadosGerais,
  updateTags,
  updateInformacoesComplementares,
  downloadAnexoAnaliseRiscoPrivacidade,
  updateAnexoAnaliseRiscoPrivacidadeResultado,
  updateCaracteristicaContratacao,
  updateComprador,
  updateDemanda,
  solicitarEsclarecimentoDemandaAnalise,
  caracteristicaContratacaoOptions,
  updateDDIManualCommand,
} from '@app/api/demanda';
import { GetPreSuprimentos } from '@app/api/configuracoes';
import { baixarTemplateRiskAssessment } from '@app/api/template';
import { getAllUsuariosSuprimentosptions } from '@app/api/usuario';

//Files
import './custom.css';
import CurrencyInput from '@app/components/CurrencyInput';
import ModalComentariosAnexoFormularioReqCompra from '../QuestionarioContratacao/ModalComentariosAnexoFormularioReqCompra';
import ModalIncluirAnexo from './ModalIncluirAnexo';
import ModalSubstituirAnexo from './ModalSubstituirAnexo';
import ModalDevolverDemanda from './ModalDevolverDemanda';
import ModalComentariosAnexoDemanda from '../QuestionarioContratacao/ModalComentariosAnexoDemanda';
import ModalComentariosCampoDemanda from './ModalComentariosCampoDemanda';
import ModalValidarAnexoPQ from './ModalValidarAnexoPQ';
import { UploadComponent, Visibility } from '@app/components';
import ValidacaoControladoriaAnaliseDemandaPage from './ValidacaoControladoriaAnaliseDemanda';

//Utils
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import ContextDemanda from '@app/hooks/useQuestionario';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import { GetFileExtension, getLoggedId, imageFormats } from '@app/helpers';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import ModalEliminarDemanda from '../QuestionarioContratacao/ModalEliminarDemanda';
import { getAllCentroCustoOptions } from '@app/api/centrocusto';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import AnaliseDemandaHistoricoModificacao from './AnaliseDemandaHistoricoModificacao';
import ModalSelectItemServico from '../QuestionarioContratacao/ModalSelectItemServico';

const { Panel } = Collapse;

const AbaAnalise = () => {
  const { id, setUpdate, update, parametrosPreSuprimentos } = useContext(ContextDemanda);
  const [updatePage, setUpdatePage] = useState(false);
  const [dadosGerais, setDadosGerais] = useState<Demanda>();
  const [statusCodigo, setStatusCodigo] = useState<number>();
  const [childrenTags, setChildrenTags] = useState([]);
  const [anexosFormularioReqCompra, setAnexosFormularioReqCompra] = useState([]);
  const [dadosInformacoesComplementares, setDadosInformacoesComplementares] = useState<any>({});
  const [configAnaliseRiscoPrivacidade, setConfigAnaliseRiscoPrivacidade] = useState<boolean>(false);
  const [loggedId] = useState(getLoggedId());
  const [exibirModalValidarAnexoPQ, setExibirModalValidarAnexoPQ] = useState<boolean>(false);
  const [valuesAnexoAprovar, setValuesAnexoAprovar] = useState<any>({});
  const [disabledDDI, setDisabledDDI] = useState(true);

  const [centroCustoOptions, setCentroCustoOptions] = useState<OptionProps[]>([]);

  const {
    demandaData,
    isGPC,
  } = useContext(QuestionarioContextProvider);

  const onUpdate = () => {
    setUpdatePage(!updatePage);
    setUpdate(!update);
  };

  useEffect(() => {
    if (id) {
      getDadosGerais(id).then((data: any) => {
        if (data) {
          setDadosGerais(data);
          setStatusCodigo(data.statusDemandaCodigo);
          //demanda codigo for abaixo de 5221 e o step for maior ou igual a "3", ai exiba o campo
          if(data.identificador < 5221 && data.step >=3 && hasPermissionPerfil([EGuidPerfilAcesso.PreContratacao])){
            setDisabledDDI(false);
          }
        }
      });
      getAnexoFormularioReqCompraApi(id).then(data => setAnexosFormularioReqCompra(data));
    }
  }, [demandaData, updatePage]);

  useEffect(() => {
    GetPreSuprimentos().then(resp => {
      if (resp) {
        setConfigAnaliseRiscoPrivacidade(resp.preSuprimentosAnaliseRiscoPrivacidade);
      }
    });
  }, []);

  useEffect(() => {
    if (dadosGerais) {
      setDadosInformacoesComplementares({
        ...dadosInformacoesComplementares,
        expectativaDePrazo: dadosGerais.expectativaDePrazo,
      });

      getAllCentroCustoOptions()
        .then((resp) => {
          if (resp.valid) {
            let opts = [...resp, { text: 'N/A', value: 'na' }];
            setCentroCustoOptions(opts);
          }
        })
    }
  }, [dadosGerais]);

  const handleSubmitInformacoes = (values: any) => {
    const submit = {} as any;
    submit.id = id;
    submit.expectativaDePrazo = values.expectativaDePrazo;
    submit.haveraDespesasReembolsaveis = values.haveraDespesasReembolsaveis;
    submit.haveraMaoDeObraEmPTR = values.haveraMaoDeObraEmPTR;
    submit.haveraSla = values.haveraSla;
    submit.novoPrazo = values.novoPrazo;
    submit.isVisitaTecnica = values.isVisitaTecnica;

    submit.expectativaDePrazoStatus = values.expectativaDePrazoStatus;
    submit.haveraDespesasReembolsaveisStatus = values.haveraDespesasReembolsaveisStatus;
    submit.haveraMaoDeObraEmPTRStatus = values.haveraMaoDeObraEmPTRStatus;
    submit.haveraSlaStatus = values.haveraSlaStatus;
    submit.novoPrazoStatus = values.novoPrazoStatus;
    submit.isVisitaTecnicaStatus = values.isVisitaTecnicaStatus;
    updateInformacoesComplementares(submit).then(data => onUpdate());
  };

  const handleUpdateAnexoAnaliseRiscoPrivacidadeResultado = values => {
    updateAnexoAnaliseRiscoPrivacidadeResultado(values).then(data => {
      onUpdate();
    });
  };

  const handleEsclarecimentoDemandaCapexOpexContaResultado = () => {
    if (demandaData && demandaData.id) {
      solicitarEsclarecimentoDemandaAnalise(demandaData.id).then((data: any) => {
        if (data.valid && dadosGerais) {
          onUpdate();

          if (dadosGerais.opex === true && hasPermission(['PRE_SUPRIMENTOS_DEMANDA_MENU_CONTROLADORIA_VISUALIZAR'])) {
            window.location.href = '/demanda/controladoria';
          }
        }
      });
    }
  };

  const handleDevolverDemandaCapexOpexContaResultado = () => {
    if (id) {
      devolverDemanda({ id: id, justificativa: '' }).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleAprovarDemandaCapexOpexContaResultado = () => {
    if (id) {
      aprovarDemanda(id).then((data: any) => {
        if (data && data.valid && dadosGerais) {
          onUpdate();
          if (dadosGerais.opex === true && hasPermission(['PRE_SUPRIMENTOS_DEMANDA_MENU_CONTROLADORIA_VISUALIZAR'])) {
            window.location.href = '/demanda/controladoria';
          }
        }
      });
    }
  };

  const handleExcluir = (id: string) => {
    excluirAnexo(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleAssumir = () => {
    if (id) {
      assumirDemanda(id).then(data => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleAprovar = () => {
    if (id) {
      aprovarDemanda(id).then((data: any) => {
        if (data && data.valid) {
          onUpdate();
        }
      });
    }
  };

  const handleUpdateAnexoFormularioReqCompraAprovacao = values => {
    updateAnexoFormularioReqCompraAprovacao(values).then(data => {
      onUpdate();
    });
  };

  const handleDownloadTudo = () => {
    if (id) {
      baixarTudoDadosGerais(id);
    }
  };

  const handleUpdateAnexoAprovacao = values => {
    if (values.descricaoDocumento === 'Planilha de Quantidades' && values.aprovado === 1) {
      setValuesAnexoAprovar(values);
      setExibirModalValidarAnexoPQ(true);
    } else {
      setValuesAnexoAprovar({});
      setExibirModalValidarAnexoPQ(false);
      updateAnexoAprovacao(values).then(data => {
        onUpdate();
      });
    }
  };

  const handleUpdateTags = (tags: string[]) => {
    if (id) {
      updateTags({ id: id, tags });
    }
  };

  const handleUpdateCaracteristicaContratacao = (caracteristica: string) => {
    if (id) {
      updateCaracteristicaContratacao({ id: id, caracteristica }).then(data => {
        onUpdate();
      });
    }
  };

  const handleUpdateComprador = (value: string) => {
    if (id) {
      updateComprador({ id: id, compradorId: value }).then(data => {
        onUpdate();
      });
    }
  };

  const statusAguardandoAnaliseControleFinanceiro = 
    [
      EStatusDemanda.AguardandoAnaliseControleFinanceiro, 
      EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao, 
      EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao
    ].includes(statusCodigo || 0);
  const statusAguardandoAnaliseControladoria = 
    [
      EStatusDemanda.AguardandoAnaliseControladoria, 
      EStatusDemanda.AguardandoAnaliseControladoriaModificacao, 
      EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao
    ].includes(statusCodigo || 0);
  const reavaliacaoRequisicaoCompra = 
    [
      EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao, 
      EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao
    ].includes(statusCodigo || 0);
  const widgetActions = () => {
    const actions = [];

    if (dadosGerais) {
      if (statusAguardandoAnaliseControleFinanceiro) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_DEVOLVER_CAPEX'])) {
          actions.push(
            <Button
              type="danger"
              id='mrn-button-capex-devolver'
              onClick={handleDevolverDemandaCapexOpexContaResultado}>
              Devolver
            </Button>,
          );
          
          if (reavaliacaoRequisicaoCompra) {
            actions.push(
              <ModalEliminarDemanda
                label="Reprovar"
                update={update}
                setUpdate={setUpdate}
                cancelarOcDemanda={reavaliacaoRequisicaoCompra} />,
            );
          }
        }
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_CAPEX'])) {
          actions.push(
            <Button
              type="success"
              id='mrn-button-capex-aprovar'
              onClick={handleAprovarDemandaCapexOpexContaResultado}>
              Validar
            </Button>,
          );
        }
      }

      if (statusAguardandoAnaliseControladoria) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_SOLICITAR_ESCLARECIMENTO']) && (demandaData && demandaData.opex)) {
          actions.push(
            <Button
              id='mrn-button-opex-esclarecimento'
              type="link"
              icon='reports-graph_report'
              onClick={handleEsclarecimentoDemandaCapexOpexContaResultado}>
              Solicitar esclarecimentos
            </Button>,
          );
        }
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_DEVOLVER'])) {
          actions.push(
            <ModalEliminarDemanda
              label="Reprovar"
              update={update}
              setUpdate={setUpdate}
              cancelarOcDemanda={reavaliacaoRequisicaoCompra} />,
          );
        }
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_APROVAR'])) {
          actions.push(
            <Button
              type="success"
              id='mrn-button-opex-validar'
              onClick={handleAprovarDemandaCapexOpexContaResultado}>
              Validar
            </Button>,
          );
        }
      }

      if (statusCodigo === EStatusDemanda.AguardandoAnalisePreSuprimentos) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_ASSUMIR'])) {
          if (dadosGerais.responsavelGpcId !== getLoggedId()) {
            actions.push(
              <Button
                id='mrn-button-assumir'
                type="link" onClick={handleAssumir}>
                Assumir
              </Button>,
            );
          }
        }
      }

      if (
        (statusCodigo === EStatusDemanda.AguardandoAnaliseSuprimentos && dadosGerais.compradorId == loggedId) ||
        (statusCodigo === EStatusDemanda.AguardandoAnalisePreSuprimentos && dadosGerais.responsavelGpcId == loggedId)
      ) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_DEVOLVER'])) {
          actions.push(<ModalDevolverDemanda onUpdate={onUpdate} />);
        }
      }

      if (statusCodigo === EStatusDemanda.AguardandoAnalisePreSuprimentos) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR']) && dadosGerais.responsavelGpcId == loggedId) {
          actions.push(
            <Button
              id='mrn-button-responsavelGpcId-validar'
              type="success" onClick={handleAprovar}>
              Validar
            </Button>,
          );
        }
      }

      if (statusCodigo === EStatusDemanda.AguardandoAnaliseSuprimentos) {
        if (hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONCLUIR']) && dadosGerais.compradorId == loggedId) {
          actions.push(
            <Button type="success" onClick={handleAprovar}>
              Concluir
            </Button>,
          );
        }
      }
    }

    return actions;
  };

  const columnsAnexoFormularioReqCompra = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
      width: '45%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'nome',
      width: '20%'
    },
    {
      title: 'Ações',
      className: 'td-centralizado',
      width: '10%',
      render: (index, record) => (
        <>
          {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO_FORMULARIO_REQ_COMPRA']) &&
            statusAguardandoAnaliseControleFinanceiro ? (
            <Tooltip title="Adicionar Arquivo">
              <UploadComponent
                id={record.id}
                nomeIdFormulario={'Id'}
                enderecoApi={'anexoDemanda/UploadAnexoFormularioReqCompra'}
                idDoComponente={record.id}
                iconName="messaging-attach"
                retorno={async data => {
                  if (data.valid) {
                    onUpdate();
                  }
                }}
                hasFile={record.local}
              />
            </Tooltip>
          ) : (
            <></>
          )}
          {record.local && (
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  style={{ marginLeft: '10px' }}
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoFormularioReqCompra(record.id, record.nome);
                  }}
                />
              </Tooltip>
            </>
          )}
        </>
      ),
    },
    {
      title: 'Comentários',
      dataIndex: 'historicoComentariosAnexoDemanda',
      width: '10%',
      className: 'td-centralizado',
      render: (index, record) => {
        return (
          <Tooltip title="Comentários">
            <ModalComentariosAnexoFormularioReqCompra
              preSuprimentos={false}
              anexoId={record.id}
              contemComentario={record.contemComentarios}
            />
          </Tooltip>
        );
      },
    },
    {
      title: 'Status',
      width: '15%',
      render: (text, record) => (
        <FormSelect
          name="aprovado"
          id={`mrn-select-status-${record.id}`}
          value={record.aprovado === undefined ? undefined : record.aprovado ? 1 : 0}
          onChange={e => handleUpdateAnexoFormularioReqCompraAprovacao({ id: record.id, aprovado: e })}
          options={[
            { text: 'Validado', value: 1 },
            { text: 'Devolvido', value: 0 },
          ]}
          disabled={
            !statusAguardandoAnaliseControleFinanceiro ||
            !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_ANEXO_FORMULARIO_REQ_COMPRA'])
          }
        />
      ),
    },
  ];

  const columnsAnexo = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
      width: '45%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'arquivoAtual.nome',
      width: '20%',
    },
    {
      title: 'Ações',
      width: '10%',
      className: 'td-centralizado',
      render: (index, record) => (
        <>
          {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) &&
            dadosGerais.statusDemandaCodigo == EStatusDemanda.AguardandoAnalisePreSuprimentos &&
            dadosGerais.responsavelGpcId == loggedId ? (
            <>
              {record.arquivoAtual && record.arquivoAtual.local ? (
                <ModalSubstituirAnexo record={record} onUpdate={onUpdate} />
              ) : (
                <Tooltip title="Anexar">
                  <UploadComponent
                    id={record.arquivos[0].id}
                    nomeIdFormulario={'Id'}
                    enderecoApi={'anexoDemanda/UploadSuprimentos'}
                    idDoComponente={record.arquivos[0].id}
                    iconName="messaging-attach"
                    retorno={async data => {
                      if (data.valid) {
                        onUpdate();
                      }
                    }}
                    hasFile={record.arquivoAtual && record.arquivoAtual.local}
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {[3, 4, 10].includes(dadosGerais.statusDemandaCodigo) &&
            hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) &&
            dadosGerais.responsavelGpcId == loggedId &&
            record.descricaoDocumento.includes('Minuta') ? (
            <>
              {record.arquivoAtual && record.arquivoAtual.local ? (
                <ModalSubstituirAnexo record={record} onUpdate={onUpdate} />
              ) : (
                <Tooltip title="Anexar">
                  <UploadComponent
                    id={record.arquivos[0].id}
                    nomeIdFormulario={'Id'}
                    enderecoApi={'anexoDemanda/UploadSuprimentos'}
                    idDoComponente={record.arquivos[0].id}
                    iconName="messaging-attach"
                    retorno={async data => {
                      if (data.valid) {
                        onUpdate();
                      }
                    }}
                    hasFile={record.arquivoAtual && record.arquivoAtual.local}
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <></>
          )}

          {record.obrigatorio === false &&
            hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) &&
            dadosGerais.statusDemandaCodigo == EStatusDemanda.AguardandoAnalisePreSuprimentos &&
            dadosGerais.responsavelGpcId == loggedId ? (
            <Tooltip title="Excluir">
              <Button
                icon="science-minus"
                type="link"
                title=""
                onClick={() => {
                  handleExcluir(record.id);
                }}
              />
            </Tooltip>
          ) : (
            <></>
          )}

          {record.arquivoAtual && record.arquivoAtual.local && (
            <>
              <Tooltip title="Download Arquivo">
                <Button
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                  }}
                />
              </Tooltip>
              {GetFileExtension(record.arquivoAtual.nome) === 'pdf' ||
                imageFormats.includes(GetFileExtension(record.arquivoAtual.nome)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    icon="files-view_file"
                    type="link"
                    onClick={() => {
                      viewAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                    }}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Comentários',
      width: '10%',
      dataIndex: 'contemComentarios',
      className: 'td-centralizado',
      render: (index, record) => {
        if (dadosGerais.responsavelGpcId == loggedId || dadosGerais.compradorId == loggedId) {
          return (
            <Tooltip title="Comentários">
              <ModalComentariosAnexoDemanda
                preSuprimentos={true}
                anexoId={record.id}
                contemComentario={record.contemComentarios}
              />
            </Tooltip>
          );
        } else return <></>;
      },
    },
    {
      title: 'Status',
      width: '15%',
      render: (text, record) => (
        <FormSelect
          id={`mrn-select-status-${record.id}`}
          name="aprovado"
          value={record.aprovado === undefined ? record.aprovado : record.aprovado ? 1 : 0}
          onChange={e =>
            handleUpdateAnexoAprovacao({ id: record.id, aprovado: e, descricaoDocumento: record.descricaoDocumento })
          }
          options={[
            { text: 'Validado', value: 1 },
            { text: 'Devolvido', value: 0 },
          ]}
          disabled={
            dadosGerais.statusDemandaCodigo != 2 ||
            !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_ANEXO']) ||
            dadosGerais.responsavelGpcId !== loggedId
          }
        />
      ),
    },
  ];

  const columnsAnexoAnaliseRiscoPrivacidade = [
    {
      title: 'Descrição',
      dataIndex: 'descricaoDocumento',
      width: '45%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'nome',
    },
    {
      title: 'Ações',
      width: '10%',
      className: 'td-centralizado',
      render: (index, record) => (
        <>
          {record && dadosGerais.responsavelGpcId == loggedId && (
            <>
              {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) && dadosGerais.statusDemandaCodigo == 2 && (
                <Tooltip title="Adicionar Arquivo">
                  <UploadComponent
                    nomeIdFormulario={'id'}
                    key={record.id}
                    id={record.id}
                    retorno={() => onUpdate()}
                    iconName={'ui-upload'}
                    idDoComponente={record.id}
                    hasFile={false}
                    enderecoApi={'anexoDemanda/UploadAnexoAnaliseRiscoPrivacidade'}
                  />
                </Tooltip>
              )}
              <Tooltip title="Download Arquivo">
                <Button
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoAnaliseRiscoPrivacidade(record.id, record.nome);
                  }}
                />
              </Tooltip>
              {record.temResultado && (
                <Tooltip title="Download Template">
                  <Button icon="business-new_resume_template" onClick={() => baixarTemplateRiskAssessment()} />
                </Tooltip>
              )}
            </>
          )}
        </>
      ),
    },
    {
      title: 'Resultado',
      dataIndex: 'resultado',
      width: '15%',
      render: (text, record) => (
        <>
          {record.temResultado && (
            <FormSelect
              name="resultado"
              value={record.resultado}
              onChange={e => handleUpdateAnexoAnaliseRiscoPrivacidadeResultado({ id: record.id, resultado: e })}
              options={[
                { text: 'Privacy Assessment', value: 'Privacy Assessment' },
                { text: 'Contratação Padrão', value: 'Contratação Padrão' },
              ]}
              disabled={
                dadosGerais.statusDemandaCodigo != 2 ||
                !hasPermission(['PRE_SUPRIMENTOS_DEMANDA_APROVAR_ANEXO']) ||
                dadosGerais.responsavelGpcId !== loggedId
              }
            />
          )}
        </>
      ),
    },
  ];

  const columnsInformacoesComplementares = (form: FormikProps<any>) => {
    const columns: ColumnProps<any>[] = [];
    columns.push({
      title: 'descrição',
      dataIndex: 'descricao',
    });

    columns.push({
      title: 'resposta',
      width: '10%',
      render: (text, record) => {
        if (dadosGerais) {
          if (record.id === 'expectativaDePrazo') {
            return (
              <FormInput
                id='mrn-input-expectativaDePrazo'
                name={record.id}
                onPressEnter={e => form.submitForm()}
                required
                validateSchema={Yup.number().required('Campo obrigatório.').typeError('Número inválido.')}
                disabled={dadosGerais.responsavelGpcId !== loggedId
                  || statusCodigo !== EStatusDemanda.AguardandoAnalisePreSuprimentos}
              />
            );
          } else if (record.id === 'novoPrazo') {
            return (
              <FormDatePicker
                id='mrn-input-novoPrazo'
                name={record.id}
                format="DD/MM/YYYY"
                onChange={e => {
                  form.setFieldValue('novoPrazo', e);
                  form.submitForm();
                }}
                required
                disabled={dadosGerais.responsavelGpcId !== loggedId
                  || statusCodigo !== EStatusDemanda.AguardandoAnalisePreSuprimentos}
              />
            );
          } else {
            return (
              <FormSelect
                id={`mrn-select-resposta-${record.id}`}
                options={optionsSwitch}
                name={record.id}
                onSelect={e => form.submitForm()}
                disabled={dadosGerais.responsavelGpcId !== loggedId
                  || statusCodigo !== EStatusDemanda.AguardandoAnalisePreSuprimentos}
              />
            );
          }
        }
        return <></>;
      },
    });

    columns.push({
      title: 'Comentários',
      width: '10%',
      dataIndex: 'contemComentarios',
      className: 'td-centralizado',
      render: (text, record) => (
        <>
          {(dadosGerais.responsavelGpcId == loggedId || dadosGerais.compradorId == loggedId) && (
            <ModalComentariosCampoDemanda
              idDoComponente='mrn-modal-ModalComentariosCampoDemanda'
              demandaId={id || ''}
              preSuprimentos={true}
              campoId={record.id} />
          )}
        </>
      ),
    });

    columns.push({
      title: 'Status',
      width: '15%',
      render: (text, record) => (
        <FormSelect
          id={`mrn-select-status-${record.id}`}
          name={record.id + 'Status'}
          onSelect={e => form.submitForm()}
          options={[
            { text: 'CONSISTENTE', value: 'consistente' },
            { text: 'INCONSISTENTE', value: 'inconsistente' },
          ]}
          disabled={dadosGerais.responsavelGpcId !== loggedId
            || statusCodigo !== EStatusDemanda.AguardandoAnalisePreSuprimentos}
        />
      ),
    });
    return columns;
  };

  const camposInformacoesComplementares = useMemo(() => {
    const campos = [];
    if (dadosGerais) {
      if (dadosGerais.tipo == 1) {
        campos.push({
          id: 'expectativaDePrazo',
          descricao: 'Expectativa de Prazo em meses',
        });
        campos.push({
          id: 'haveraMaoDeObraEmPTR',
          descricao: 'Mão de Obra em Porto Trombetas',
        });
        campos.push({
          id: 'haveraSla',
          descricao: 'SLA',
        });
        campos.push({
          id: 'haveraDespesasReembolsaveis',
          descricao: 'Despesas Reembolsáveis',
        });
        campos.push({
          id: 'isVisitaTecnica',
          descricao: 'Visita Técnica',
        });
      }
      if (dadosGerais.tipo == 2 && dadosGerais.isPrazo) {
        campos.push({
          id: 'novoPrazo',
          descricao: 'Novo Prazo',
        });
      }
    }
    return campos;
  }, [id, dadosGerais]);

  const onUpdateDemanda = (demanda: Demanda) => {
    updateDemanda(demanda).then((resp: any) => {
      if (resp.valid) {
        onUpdate();
      }
    });
  }
  
  const emModificacao = !!dadosGerais && !!dadosGerais.isModificando;

  const renderWidget = () => (
    dadosGerais &&
    <>
      <Row>
        <FormInput
          id="mrn-input-codOrdemInvestimento"
          name="codOrdemInvestimento"
          label="Ordem Investimento"
          value={dadosGerais.capex ? dadosGerais.codOrdemInvestimento : 'N/A'}
          span={4}
          disabled />
        <FormInput
          id="mrn-input-ordemInvestimento"
          name="ordemInvestimento"
          label="Descrição Ordem Investimento"
          value={dadosGerais.capex ? dadosGerais.ordemInvestimento : 'N/A'}
          span={4}
          disabled />
        <FormSelect
          id="mrn-select-requisicaoAbertaPeloDepPlanejamentoControle"
          options={optionsSwitch}
          name="requisicaoAbertaPeloDepPlanejamentoControle"
          label="A Requisição será aberta pelo Dep. de Planejamento e Controle?"
          span={4}
          disabled
        />
      </Row>
      <Row>
        <FormInput
          name="pacote"
          id='mrn-input-pacote'
          label="Pacote"
          value={dadosGerais.capex ? dadosGerais.pacote : 'N/A'}
          span={4} disabled />
        <FormInput
          name="projeto"
          id='mrn-input-projeto'
          label="Projeto"
          value={dadosGerais.capex ? dadosGerais.projeto : 'N/A'}
          span={4} disabled />
        <FormSelect
          id='mrn-select-temPrevisaoOrcamentaria'
          options={optionsSwitch}
          label="Está previsto na peça Orçamentária?"
          name="temPrevisaoOrcamentaria"
          span={4}
          required
          onSelect={value => {
            let dem = { ...dadosGerais, temPrevisaoOrcamentaria: value } as Demanda;
            onUpdateDemanda(dem);
          }}
          disabled={!statusAguardandoAnaliseControleFinanceiro}
        />
      </Row>
      <Row>
        <FormSelect
          label="Centro de Custo"
          name="codCentroDeCusto"
          id='mrn-select-centroDeCusto'
          span={2}
          value={!dadosGerais.capex ? dadosGerais.codCentroDeCusto : 'N/A'}
          options={centroCustoOptions}
          disabled
        />
        <FormInput
          label="Descrição"
          name="centroDeCusto"
          id='mrn-input-centroDeCusto'
          value={!dadosGerais.capex ? dadosGerais.centroDeCusto : 'N/A'}
          span={4}
          disabled />
      </Row>
    </>
  );

  const renderWidgetModificacao = () => (
    emModificacao &&
    <fieldset>
      <legend>Validação Controle Financeiro</legend>
      <AnaliseDemandaHistoricoModificacao />
      { 
        dadosGerais.capex &&
        <>
          <Row>
            <FormInput
              id="mrn-input-codOrdemInvestimento"
              name="codOrdemInvestimento"
              label="Ordem Investimento"
              value={dadosGerais.capex ? dadosGerais.codOrdemInvestimento : 'N/A'}
              span={4}
              disabled />
            <FormInput
              id="mrn-input-ordemInvestimento"
              name="ordemInvestimento"
              label="Descrição Ordem Investimento"
              value={dadosGerais.capex ? dadosGerais.ordemInvestimento : 'N/A'}
              span={4}
              disabled />
            <FormSelect
              id="mrn-select-requisicaoAbertaPeloDepPlanejamentoControle"
              options={optionsSwitch}
              name="requisicaoAbertaPeloDepPlanejamentoControle"
              label="A Requisição será aberta pelo Dep. de Planejamento e Controle?"
              span={4}
              disabled
            />
          </Row>
          <Row>
            <FormInput
              name="pacote"
              id='mrn-input-pacote'
              label="Pacote"
              value={dadosGerais.capex ? dadosGerais.pacote : 'N/A'}
              span={4} disabled />
            <FormInput
              name="projeto"
              id='mrn-input-projeto'
              label="Projeto"
              value={dadosGerais.capex ? dadosGerais.projeto : 'N/A'}
              span={4} disabled />
            <FormSelect
              id='mrn-select-temPrevisaoOrcamentaria'
              options={optionsSwitch}
              label="Está previsto na peça Orçamentária?"
              name="temPrevisaoOrcamentaria"
              span={4}
              required
              onSelect={value => {
                let dem = { ...dadosGerais, temPrevisaoOrcamentaria: value } as Demanda;
                onUpdateDemanda(dem);
              }}
              disabled={!statusAguardandoAnaliseControleFinanceiro}
            />
          </Row>
        </>
      }
      {
        dadosGerais.contaResultado &&
        <>
          <Row>
            <ModalSelectItemServico disabled={true} span={6} itemServicoSelecionado={dadosGerais.codItemServico} />
            <FormSelect
              label="Centro de Custo"
              name="codCentroDeCusto"
              id='mrn-select-centroDeCusto'
              span={2}
              value={dadosGerais.codCentroDeCusto}
              getOptions={getAllCentroCustoOptions}
              disabled
            />
            <FormInput
              label="Centro de Custo"
              name="centroDeCusto"
              id='mrn-input-centroDeCusto'
              value={dadosGerais.centroDeCusto}
              span={4}
              disabled />
          </Row>

          <Row>
            <FormInput
              label="Id orçamento"
              name='orcamentoId'
              id='mrn-input-orcamentoId'
              span={4} disabled />
            <Row>
              <FormSelect
                id='mrn-select-temPrevisaoOrcamentaria'
                options={optionsSwitch}
                label="Está previsto na peça Orçamentária?"
                name="temPrevisaoOrcamentaria"
                span={4}
                disabled={true}
              />
            </Row>
          </Row>
        </>
      }
    </fieldset>
  );

  return (
    <>
      {(dadosGerais && demandaData) ? (
        <Collapse id="mrn-collapse-aba-analise" bordered={false} defaultActiveKey={'analise'} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="analise"
            header={
              <span>
                {dadosGerais.identificadorTexto} - {dadosGerais.status}
              </span>
            }>
            <Widget actions={widgetActions()}>
              {(statusAguardandoAnaliseControleFinanceiro ||
                statusCodigo === EStatusDemanda.AguardandoRCDemandante) && (
                  <Row>
                    <MasterDetailForm initialValues={dadosGerais}>
                      {emModificacao === false && renderWidget()}

                      {emModificacao && renderWidgetModificacao()}

                      <fieldset>
                        <Row>
                          <Table
                            id="mrn-table-analise-anexosFormularioReqCompra"
                            columns={columnsAnexoFormularioReqCompra} dataSource={anexosFormularioReqCompra} />
                        </Row>
                      </fieldset>
                    </MasterDetailForm>
                  </Row>
                )}

              <Visibility
                visible={dadosGerais.opex === true &&
                  [
                    ETipoDemanda.NovaContratacao,
                    ETipoDemanda.Aditivo,
                  ].includes(dadosGerais.tipo || 0) &&
                  [
                    EStatusDemanda.AguardandoRCDemandante,
                    EStatusDemanda.AguardandoAnaliseControladoria,
                    EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                    EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
                  ].includes(statusCodigo || 0)}
                permissions={['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_RESPONSAVEL_VALIDACAO']}
              >
                <ValidacaoControladoriaAnaliseDemandaPage
                  update={update}
                  setUpdate={setUpdate}
                />
              </Visibility>

              <Visibility
                visible={!statusAguardandoAnaliseControladoria && !statusAguardandoAnaliseControleFinanceiro}
              >

                <Visibility
                  visible={dadosGerais.anexosDemanda.length > 0}
                >
                  <ModalValidarAnexoPQ
                    onUpdate={onUpdate}
                    exibirModal={exibirModalValidarAnexoPQ}
                    setExibirModal={setExibirModalValidarAnexoPQ}
                    values={valuesAnexoAprovar}
                  />
                  <Row>
                    <MasterDetailForm>
                      <fieldset>
                        <legend>Anexos</legend>
                        <Row>
                          {dadosGerais.responsavelGpcId == loggedId && <ModalIncluirAnexo onUpdate={onUpdate} />}
                          <Table
                            id="mrn-table-analise-anexos"
                            columns={columnsAnexo} dataSource={dadosGerais.anexosDemanda} />
                        </Row>
                        {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_BAIXAR_TODOS_ANEXOS']) && (
                          <Row>
                            <Button style={{ float: 'right' }} onClick={() => handleDownloadTudo()}>
                              Baixar Tudo
                            </Button>
                          </Row>
                        )}
                      </fieldset>
                    </MasterDetailForm>
                  </Row>
                </Visibility>

                <Visibility
                  visible={!isGPC && camposInformacoesComplementares.length > 0}
                >
                  <Row>
                    <MasterDetailForm initialValues={dadosGerais} onSubmit={handleSubmitInformacoes}>
                      <FormContext.Consumer>
                        {({ formProps }) => (
                          <fieldset>
                            <legend>Informações Complementares</legend>
                            <Table
                              id="mrn-table-analise-informacoesComplementares"
                              columns={columnsInformacoesComplementares(formProps)}
                              dataSource={camposInformacoesComplementares}
                              rowKey="id"
                            />
                          </fieldset>
                        )}
                      </FormContext.Consumer>
                    </MasterDetailForm>
                  </Row>
                </Visibility>

                <Visibility
                  visible={!isGPC && configAnaliseRiscoPrivacidade && dadosGerais.tipo === ETipoDemanda.NovaContratacao}
                >
                  <MasterDetailForm>
                    <Row style={{ paddingTop: '20px', paddingBottom: '10px' }}>
                      <fieldset>
                        <legend>Análise de Risco de Privacidade</legend>
                        <Table
                          id="mrn-table-analise-analiseRiscoPrivacidade"
                          columns={columnsAnexoAnaliseRiscoPrivacidade}
                          dataSource={dadosGerais.anexoDemandaAnaliseRiscoPrivacidade}
                        />
                      </fieldset>
                    </Row>
                  </MasterDetailForm>
                </Visibility>

              </Visibility>

              {dadosGerais.tipo == ETipoDemanda.NovaContratacao &&
                (statusCodigo === EStatusDemanda.AguardandoAnaliseSuprimentos ||
                  statusCodigo === EStatusDemanda.Concluido ||
                  statusCodigo === EStatusDemanda.AguardandoGeracaoOCePreSuprimentosDDI) && (
                  <Row>
                    <MasterDetailForm initialValues={dadosGerais} onSubmit={updateDDIManualCommand}>
                      <fieldset>
                        <legend>DDI - Due Diligence de Integridade</legend>
                        <Row>
                          <FormInput label="Prazo em meses" name="expectativaDePrazo" span={2} disabled />
                          <CurrencyInput
                            label="Expectativa de Valor Final"
                            name="expectativaValorFinal"
                            span={4}
                            disabled
                          />
                          <FormSelect
                            label="Característica de Contratação"
                            name="caracteristicaContratacao"
                            getOptions={caracteristicaContratacaoOptions}
                            span={4}
                            disabled={disabledDDI}
                          />
                          <FormSwitch label="Elegível DDI?" name="isDdi" span={2} disabled={disabledDDI} />
                        </Row>
                        {!disabledDDI && (
                          <FormSubmitButton
                            noIcon={true}
                            title="Salvar"
                            type="primary"
                          />
                        )}
                      </fieldset>
                    </MasterDetailForm>
                  </Row>
                )}

              {statusCodigo === EStatusDemanda.AguardandoAnaliseSuprimentos ||
                statusCodigo === EStatusDemanda.Concluido ? (
                <Row>
                  {dadosGerais.tipo == ETipoDemanda.NovaContratacao ? (
                    <MasterDetailForm initialValues={dadosGerais}>
                      <fieldset>
                        <legend>Suprimentos</legend>
                        <Row>
                          <FormInput label="Req. Compra" name="requisicaoCompra" span={3} disabled />
                          <FormInput label="Ordem de Compra" name="ordemCompra" span={3} disabled />
                          <FormSelect
                            getOptions={getAllUsuariosSuprimentosptions}
                            name="compradorId"
                            label="Nome do Comprador"
                            span={4}
                            onChange={e => handleUpdateComprador(e)}
                            disabled={
                              dadosGerais.statusDemandaCodigo != 5 ||
                              !hasPermission(['SAS_ALTERAR_COMPRADOR'])
                            }
                          />
                          <FormInput name="compradorERP" label="Identificador ERP Comprador" span={2} disabled />
                        </Row>
                      </fieldset>
                    </MasterDetailForm>
                  ) : (
                    <></>
                  )}

                  {dadosGerais.tipo === ETipoDemanda.Aditivo ? (
                    <MasterDetailForm initialValues={dadosGerais}>
                      <fieldset>
                        <legend>Suprimentos</legend>
                        {dadosGerais.isPrazo && (
                          <Row>
                            <FormDatePicker
                              format="DD/MM/YYYY"
                              label="Prazo Atual do Contrato"
                              name="prazoAtual"
                              span={4}
                              disabled
                            />
                            <FormDatePicker format="DD/MM/YYYY" label="Novo Prazo" name="novoPrazo" span={4} disabled />
                          </Row>
                        )}
                        {(dadosGerais.isValorComAcrescimoEscopo || dadosGerais.isValorSemAcrescimoEscopo) && (
                          <Row>
                            <CurrencyInput label="Valor Atual" name="valorAtual" span={4} disabled />
                            <CurrencyInput label="Valor Aditivo" name="valorAditivo" span={4} disabled />
                            <CurrencyInput label="Novo Valor Final" name="novoValorFinal" span={4} disabled />
                          </Row>
                        )}

                        {dadosGerais.isPrazo && (
                          <Row>
                            <FormTextArea
                              label="Resumo Alterações Cláusulas"
                              name="resumoAlteracoesClausula"
                              rows={1}
                              span={12}
                              disabled
                            />
                          </Row>
                        )}
                      </fieldset>
                    </MasterDetailForm>
                  ) : (
                    <></>
                  )}
                </Row>
              ) : (
                <></>
              )}

              {!isGPC && !statusAguardandoAnaliseControladoria && !statusAguardandoAnaliseControleFinanceiro
               ? (
                <Row>
                  {dadosGerais.tipo == 1 && (
                    <MasterDetailForm initialValues={dadosGerais}>
                      <Row style={{ paddingTop: '32px' }}>
                        <FormSelect
                          label="Palavras Chaves"
                          onChange={v => handleUpdateTags(v)}
                          options={childrenTags}
                          mode="tags"
                          name="tags"
                        />
                      </Row>
                    </MasterDetailForm>
                  )}
                </Row>
              ) : (
                <></>
              )}
            </Widget>
          </Panel>
        </Collapse>
      ) : (
        <></>
      )}
    </>
  );
};

export default AbaAnalise;
